<template>
  <div>
    <ol class="am-breadcrumb">
      <li>
        <router-link :to="{path:'/edit'}" class="am-icon-home">控制台</router-link>
      </li>
      <li class="am-active">管理</li>
      <li class="am-active">用户</li>
    </ol>
    <div class="am-scrollable-horizontal">
      <table class="am-table am-table-hover am-text-nowrap">
        <thead>
          <tr>
            <th>ID</th>
            <th>头像</th>
            <th>昵称</th>
            <th>邮箱</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="user in userList" :id="`userId${user.id}`">
            <td>{{user.id}}</td>
            <td><img v-if="user.avatarUrl" :src="user.avatarUrl" class="avatar"/></td>
            <td>{{user.nickName}}<span v-if="user.expireTime" class="am-text-danger">（已禁言至{{user.expireTime}}）</span></td>
            <td>{{user.email}}</td>
            <td>
              <button class="am-btn am-btn-link" @click="muted(user.id)">设置禁言</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <ol class="am-breadcrumb">
      <li>
        <router-link :to="{path:'/edit'}" class="am-icon-home">控制台</router-link>
      </li>
      <li class="am-active">管理</li>
      <li class="am-active">用户</li>
    </ol>
  </div>
</template>

<script>
import { adminUserGetList, adminUserMuted } from '@/request'
import {MessageBox, Toast} from "mint-ui"
export default {
  name: 'EditUsers',
  data () {
    return {
      userList: []
    }
  },
  updated () {
    this.$nextTick(() => {
      const userId = this.$route.query.userId
      if(userId) {
        const anchor = this.$el.querySelector(`#userId${userId}`)
        if(anchor) {
          anchor.scrollIntoView()
        }
      }
    })
  },
  mounted () {
    this.loadUserList()
  },
  methods: {
    loadUserList () {
      adminUserGetList().then(res => {
        this.userList = res
      })
    },
    muted (id) {
      MessageBox.prompt('禁言时长（小时）：', '提示', {inputType:'number'}).then(({ value }) => {
        if(value) {
          if(value === '0') {
            adminUserMuted({ id, hour: value }).then(res => {
              Toast(res)
              this.loadUserList()
            })
          } else {
            const hour = value
            MessageBox.prompt('禁言原因：', '提示', {inputType:'text'}).then(({ value }) => {
              if(value) {
                adminUserMuted({ id, hour, reason: value }).then(res => {
                  Toast(res)
                  this.loadUserList()
                })
              }
            })
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.avatar {
  width: 30px;
  height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/EditUsers.vue